import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';
import Register from './components/Register';
import SelectPlanPage from './components/SelectPlanPage';
import { appRoutes } from './app/routes';
import { panelRoutes } from './panel/PanelRoutes';
import { onboardingRoutes } from './onboarding/routes';

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            {onboardingRoutes}
            <Route path="/select-plan" element={<SelectPlanPage />} />
            <Route element={<ProtectedRoute />}>{panelRoutes}</Route>
            {appRoutes}
          </Routes>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
